import { render, staticRenderFns } from "./InterfaceFrameView.vue?vue&type=template&id=cbad23be"
import script from "./InterfaceFrameView.vue?vue&type=script&lang=ts"
export * from "./InterfaceFrameView.vue?vue&type=script&lang=ts"
import style0 from "./InterfaceFrameView.vue?vue&type=style&index=0&id=cbad23be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports